export default "__VITE_ASSET__BCPl5a0F__"